module.exports = __webpack_public_path__ + "bdf3c74aa183294eafb63b18147028c1.png";